require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/01eb5f7ce622297dc30f6dd142cf46c8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_01eb5f7ce622297dc30f6dd142cf46c8'] = function fn_01eb5f7ce622297dc30f6dd142cf46c8(text) {
return (String((String(text)).replace((new RegExp('(\\d)(?=(\\d{3})+(?!\\d))', 'g')), '$1 ')) + String(' PLN'))
}

})
define('./functions/0f429df91b0f40b5392b7d46e052a65a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0f429df91b0f40b5392b7d46e052a65a'] = async function fn_0f429df91b0f40b5392b7d46e052a65a() {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



return (['ownerId = \'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\''].join(''))
}

})
define('./functions/2876227199e4c3f6970141db38fe155a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2876227199e4c3f6970141db38fe155a'] = function fn_2876227199e4c3f6970141db38fe155a(value) {
return (value + 1)
}

})
define('./functions/3ad9debeb7cf366b6934759314acad42/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3ad9debeb7cf366b6934759314acad42'] = async function fn_3ad9debeb7cf366b6934759314acad42(date) {
  date.setMonth(0);

return (await BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902'](date))
}

})
define('./functions/3e6beb363a8e0bbdd1ed31ed14c87a32/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3e6beb363a8e0bbdd1ed31ed14c87a32'] = async function fn_3e6beb363a8e0bbdd1ed31ed14c87a32(date) {


  return (new Date(date.getTime() - (([(await BackendlessUI.Functions.Custom['fn_8f76cb87a38a5bc7cdab59688eb9c136'](date)) * 86400, (new Date(date).getHours()) * 3600, (new Date(date).getMinutes()) * 60, (new Date(date).getSeconds())].reduce(function(x, y) {return x + y;})) * 1000)))
}

})
define('./functions/54c11b5f2675ea831fdbe54d6f597991/code.js', () => { 

BackendlessUI.Functions.Custom['fn_54c11b5f2675ea831fdbe54d6f597991'] = function fn_54c11b5f2675ea831fdbe54d6f597991(value, max) {
return (value + 1 <= max ? value + 1 : max)
}

})
define('./functions/5dcffceba15f6708c8eba19bbf187e8f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_5dcffceba15f6708c8eba19bbf187e8f'] = async function fn_5dcffceba15f6708c8eba19bbf187e8f(DateSpanString) {
var DateSpanString;


  if (DateSpanString == 'ThisWeek') {
    return (String('created >=') + String((await BackendlessUI.Functions.Custom['fn_3e6beb363a8e0bbdd1ed31ed14c87a32']((new Date()))).valueOf()));
  } else if (DateSpanString == 'LastWeek') {
    return (['created >=',((await BackendlessUI.Functions.Custom['fn_3e6beb363a8e0bbdd1ed31ed14c87a32']((new Date((new Date()).getTime() - (604800 * 1000))))).valueOf()),' and created <',((await BackendlessUI.Functions.Custom['fn_3e6beb363a8e0bbdd1ed31ed14c87a32']((new Date()))).valueOf())].join(''));
  } else if (DateSpanString == 'ThisMonth') {
    return (String('created >=') + String((await BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902']((new Date()))).valueOf()));
  } else if (DateSpanString == 'LastMonth') {
    return (['created >=',((await BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902']((new Date((await BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902']((new Date()))).getTime() - (100 * 1000))))).valueOf()),' and created <',((await BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902']((new Date()))).valueOf())].join(''));
  } else if (DateSpanString == 'ThisYear') {
    return (String('created >=') + String((await BackendlessUI.Functions.Custom['fn_3ad9debeb7cf366b6934759314acad42']((new Date()))).valueOf()));
  } else if (DateSpanString == 'LastYear') {
    return (['created >=',((await BackendlessUI.Functions.Custom['fn_3ad9debeb7cf366b6934759314acad42']((new Date((await BackendlessUI.Functions.Custom['fn_3ad9debeb7cf366b6934759314acad42']((new Date()))).getTime() - (86400 * 1000))))).valueOf()),' and created <',((await BackendlessUI.Functions.Custom['fn_3ad9debeb7cf366b6934759314acad42']((new Date()))).valueOf())].join(''));
  } else if (DateSpanString == 'Yesterday') {
    return (['created >=',((await BackendlessUI.Functions.Custom['fn_6ebfa9a178c57e29fccbf797ecd8546d']((new Date((new Date()).getTime() - (86400 * 1000))))).valueOf()),' and created <',((await BackendlessUI.Functions.Custom['fn_6ebfa9a178c57e29fccbf797ecd8546d']((new Date()))).valueOf())].join(''));
  } else {
  }

return (String(' created > ') + String((await BackendlessUI.Functions.Custom['fn_6ebfa9a178c57e29fccbf797ecd8546d']((new Date()))).valueOf()))
}

})
define('./functions/6ebfa9a178c57e29fccbf797ecd8546d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6ebfa9a178c57e29fccbf797ecd8546d'] = function fn_6ebfa9a178c57e29fccbf797ecd8546d(date) {
return (new Date(date.getTime() - (([(new Date(date).getHours()) * 3600, (new Date(date).getMinutes()) * 60, (new Date(date).getSeconds())].reduce(function(x, y) {return x + y;})) * 1000)))
}

})
define('./functions/8859944ac853b1011ca3f8faa8de9902/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902'] = function fn_8859944ac853b1011ca3f8faa8de9902(date) {
return (new Date(date.getTime() - (([((new Date(date).getDate()) - 1) * 86400, (new Date(date).getHours()) * 3600, (new Date(date).getMinutes()) * 60, (new Date(date).getSeconds())].reduce(function(x, y) {return x + y;})) * 1000)))
}

})
define('./functions/8f76cb87a38a5bc7cdab59688eb9c136/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8f76cb87a38a5bc7cdab59688eb9c136'] = function fn_8f76cb87a38a5bc7cdab59688eb9c136(date) {
var result;


  if ((new Date(date).getDay()) == 0) {
    result = 6;
  } else {
    result = (new Date(date).getDay()) - 1;
  }

return result
}

})
define('./functions/902fc5739ffa39dff8de66e4d73ddbe2/code.js', () => { 

BackendlessUI.Functions.Custom['fn_902fc5739ffa39dff8de66e4d73ddbe2'] = async function fn_902fc5739ffa39dff8de66e4d73ddbe2(value) {
return (await (async function(value) {
	return Number.parseFloat(value).toFixed(2);
})(value))
}

})
define('./functions/bbeb8b6e187dd40a2cffcfa716af6865/code.js', () => { 

BackendlessUI.Functions.Custom['fn_bbeb8b6e187dd40a2cffcfa716af6865'] = async function fn_bbeb8b6e187dd40a2cffcfa716af6865(value) {
return ((String((await BackendlessUI.Functions.Custom['fn_902fc5739ffa39dff8de66e4d73ddbe2'](value)))).replace((new RegExp('(\\d)(?=(\\d{3})+(?!\\d))', 'g')), '$1 '))
}

})
define('./functions/e79d01550639771aff59ff8862a7dc4c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e79d01550639771aff59ff8862a7dc4c'] = async function fn_e79d01550639771aff59ff8862a7dc4c(date) {
return (new Date((await BackendlessUI.Functions.Custom['fn_6ebfa9a178c57e29fccbf797ecd8546d'](date)).getTime() + (86399 * 1000)))
}

})
define('./functions/f315d0987625e6df48afb5dfc7c5187f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f315d0987625e6df48afb5dfc7c5187f'] = function fn_f315d0987625e6df48afb5dfc7c5187f(value, min) {
return (value - 1 >= min ? value - 1 : min)
}

})
define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
/* handler:onClick *//* content */
}));

define('./pages/AdminUsersList/components/003892cb9004515cd7def7562c77505e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/AdminUsersList/components/975fd35bb5cce2de28eff703a7463858/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('home', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/AdminUsersList/components/8cb8a61c45f23214420f52f9dd15322b/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9afddb89178b1824b4dc381f6a4cf7b', true);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('f9afddb89178b1824b4dc381f6a4cf7b', ___arguments.selectedRecord);

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/AdminUsersList/components/d8d31f67534f6c06ebf5f2ed1b916322/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  onWhereClauseAssignment(___arguments) {
      return (['ownerId = \'',(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['objectId']),'\''].join(''))

  },  
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/AdminUsersList/components/bb713a741dff4a3541fac8d6c9ea9b02/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['name']),' ',(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['fullName'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/AdminUsersList/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  onEnter(___arguments) {
    var filterString;


  filterString = '';
  if ((___arguments.context.pageData['userOid']) != null) {
    ___arguments.context.pageData['userCondition'] = ([' and userOid=\'',(___arguments.context.pageData['userOid']),'\' '].join(''));
    filterString = String(filterString) + String(___arguments.context.pageData['fullName']);
  } else {
    ___arguments.context.pageData['userCondition'] = '';
  }
  if ((___arguments.context.pageData['onlyToSend']) != null) {
    ___arguments.context.pageData['toSendCondition'] = (String(' and doNotSend = false') + String(' and sent = false'));
    filterString = String(filterString) + String('Nie wysłane');
  } else {
    ___arguments.context.pageData['toSendCondition'] = '';
  }
  if ((___arguments.context.pageData['contractorObjectId']) != null) {
    ___arguments.context.pageData['contractorCondition'] = ([' and contractorObjectId=\'',(___arguments.context.pageData['contractorObjectId']),'\' '].join(''));
    filterString = String(filterString) + String(___arguments.context.pageData['contractorName']);
  } else {
    ___arguments.context.pageData['contractorCondition'] = '';
  }
  if ((___arguments.context.pageData['contractor2ObjectId']) != null) {
    ___arguments.context.pageData['contractor2Condition'] = ([' and contractor2ObjectId=\'',(___arguments.context.pageData['contractor2ObjectId']),'\' '].join(''));
    filterString = String(filterString) + String(___arguments.context.pageData['contractor2Name']);
  } else {
    ___arguments.context.pageData['contractor2Condition'] = '';
  }
  ___arguments.context.pageData['filterString'] = filterString;
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c419c8685aee7b52061e942ddea88571', (filterString.length > 0));
  ___arguments.context.pageData['dateFrom'] = ((new Date((new Date()).getTime() - (86400 * 1000))).valueOf());
  ___arguments.context.pageData['dateTo'] = ((new Date()).valueOf());

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/AdminUsersList/components/c419c8685aee7b52061e942ddea88571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['filterString'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/AdminUsersList/components/3ad370ac6a1828b3d9d77cea219bc266/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['notes'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/AdminUsersList/components/eaac318d7324315251828ee4444a3a5b/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  onCheckedStateAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['doNotSend'])

  },  
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/AdminUsersList/components/2239fcfd19e51ab27069b059a69d15b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ([(await Backendless.Data.of('Document').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId=\'',(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['objectId']),'\'','and created > ',((new Date((new Date()).getTime() - (604800 * 1000))).valueOf())].join(''))))),' / ',(await Backendless.Data.of('Document').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId=\'',(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['objectId']),'\'','and created > ',((new Date((new Date()).getTime() - (604800 * 1000))).valueOf())].join(''))))),' / ',(await Backendless.Data.of('Document').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId=\'',(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['objectId']),'\''].join('')))))].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/AdminUsersList/components/615857843b177a049f3a97933a812346/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return ([(await Backendless.Data.of('Users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['objectId']),'\'','and ownerId != objectId'].join(''))))),' / ',(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['licenseSalesmansQuantity'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/ContractorCategoryListPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['PageTitle'] = 'Kategorie kontrahentów';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/ContractorCategoryListPage/components/003892cb9004515cd7def7562c77505e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ContractorCategoryListPage/components/975fd35bb5cce2de28eff703a7463858/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('home', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ContractorEditPage/components/51a9a34561f3909de40e64c8a26460b2/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Backendless.Data.of('ContractorCategory').find(Backendless.DataQueryBuilder.create().setSortBy('name').setPageSize(100)))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/ContractorEditPage/components/e8a9fce5faa414d33506667eb8bf0299/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('51a9a34561f3909de40e64c8a26460b2', '');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ContractorEditPage/components/66b72dbe139e511382bdc03959da9cbf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('569b8c38b06b0fdaf165e4dfe1aabd52', '0');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ContractorEditPage/components/569b8c38b06b0fdaf165e4dfe1aabd52/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
      return (await Backendless.Data.of('RetailChain').find(Backendless.DataQueryBuilder.create().setSortBy('name').setPageSize(100)))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/ContractorEditPage/components/30c2cc840c89b53bd7852fe3090dc5eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('92537318ad2cd7e882658a7aa659a6aa', '0');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ContractorEditPage/components/92537318ad2cd7e882658a7aa659a6aa/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
      return (await Backendless.Data.of('ContractorStatus').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId is null or ','ownerId = \'',((await Backendless.UserService.getCurrentUser(false))['objectId']),'\''].join(''))).setSortBy('name').setPageSize(50)))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/ContractorEditPage/components/8f14ba8285996f4a0683656111d79fb6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
      return (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId != \'',((await Backendless.UserService.getCurrentUser(false))['objectId']),'\''].join(''))).setSortBy('name').setPageSize(50)))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/ContractorEditPage/components/4b28a7331908cbfb92177c45615d7e23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('8f14ba8285996f4a0683656111d79fb6', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ContractorEditPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['PageTitle'] = 'Kontrahent';
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('ee6e8af85c8878e43de60e9fd38125cc', (await Backendless.Data.of('Contractor').findById((getObjectProperty(___arguments.context.pageData, 'objectId')), )));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/ContractorEditPage/components/f835663c33c8cce6a1a78fabbcf22142/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('51a9a34561f3909de40e64c8a26460b2')) != '') {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('ee6e8af85c8878e43de60e9fd38125cc'))['categoryOid'] = (JSON.parse(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('51a9a34561f3909de40e64c8a26460b2'))));
    }
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('569b8c38b06b0fdaf165e4dfe1aabd52')) != '') {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('ee6e8af85c8878e43de60e9fd38125cc'))['retailChainOid'] = (JSON.parse(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('569b8c38b06b0fdaf165e4dfe1aabd52'))));
    }
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('92537318ad2cd7e882658a7aa659a6aa')) != '') {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('ee6e8af85c8878e43de60e9fd38125cc'))['statusOid'] = (JSON.parse(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('92537318ad2cd7e882658a7aa659a6aa'))));
    }
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('8f14ba8285996f4a0683656111d79fb6')) != '') {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('ee6e8af85c8878e43de60e9fd38125cc'))['userOid'] = (JSON.parse(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('8f14ba8285996f4a0683656111d79fb6'))));
    }
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('ee6e8af85c8878e43de60e9fd38125cc'))['distributor'] = false;
    await Backendless.Data.of('Contractor').save( ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('ee6e8af85c8878e43de60e9fd38125cc')) );
    (function () { window.history.back(); })();

  } catch (error) {
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ContractorListPage/components/b8e210815cf50ef68181c84ebc2278e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ContractorCategoryListPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ContractorListPage/components/8cb8a61c45f23214420f52f9dd15322b/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['objectId'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
  ___arguments.context.pageData['objectName'] = (getObjectProperty(___arguments.selectedRecord, 'name'));

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
      return ([(await BackendlessUI.Functions.Custom['fn_0f429df91b0f40b5392b7d46e052a65a']()),' and ','distributor = false'].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/ContractorListPage/components/4fc6958b53c352fb00a9ae02cd3ae197/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('ContractorStatusListPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ContractorListPage/components/b4133c1d06e6d66fd39726a1f8bd4795/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('RetailChainListPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/ContractorListPage/components/3147a76f236ad41d81950c333a423877/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, filePath, userExportPath;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    userExportPath = String('/export/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    filePath = (await Backendless.Files.saveFile(encodePath(userExportPath), 'Contractors.csv', 'text/plain', true));
    await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': (Backendless.getCurrentUserToken()) }})).send({ 'filePath': (String(userExportPath) + String('/Contractors.csv')),'tableName': 'Contractor','tableOptions': ({ [`where`]: [(await BackendlessUI.Functions.Custom['fn_0f429df91b0f40b5392b7d46e052a65a']()),'',''].join(''),[`properties`]: ['objectId', 'name', 'identifier', 'city', 'zip', 'street', 'street', 'localNumber', 'homeNumber', 'taxId', 'email', 'phone'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`delimiter`]: ';',[`header`]: true,[`quoted`]: true,[`record_delimiter`]: 'windows' }) });
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(filePath, true, undefined);

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ContractorListPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['PageTitle'] = 'Kontrahenci';
  ___arguments.context.pageData['EditPageName'] = 'ContractorEditPage';
  ___arguments.context.pageData['TableName'] = 'Contractor';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/ContractorListPage/components/a13a2c46c557887398d4d942226c60a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('MapPage', ({ 'contractorId': (getObjectProperty(___arguments.context.pageData, 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ContractorListPage/components/f6b18ed56d895f68d58e3845ffc6b693/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, filePath, userExportPath;

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    userExportPath = '/export';
    filePath = (await Backendless.Files.saveFile(encodePath(userExportPath), 'Contractors.csv', 'text/plain', true));
    await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/csv2table`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': (Backendless.getCurrentUserToken()) }})).send({ 'csvURL': filePath,'tableName': 'Contractor' });
    (function (message) { alert(message) })(filePath);

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/ContractorStatusListPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['PageTitle'] = 'Statusy kontrahentów';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/ContractorStatusListPage/components/80f40ba1d51fae34b1e2add69bcd1cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async onWhereClauseAssignment(___arguments) {
      return (['ownerId is null or ','ownerId=\'',((await Backendless.UserService.getCurrentUser())['objectId']),'\''].join(''))

  },  
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Data/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  onEnter(___arguments) {
      ___arguments.context.pageData['tableOptions'] = ({ 'title': 'My Table','whereClause': 'objectId != null','realTime': true,'searching': true,'sorting': true,'paging': true,'allowAdd': true,'allowEdit': true,'allowDelete': true });

  },  
/* handler:onEnter *//* content */
}));

define('./pages/DetailCategoryListPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['PageTitle'] = 'Kategorie produktów';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/DetailEditPage/components/51a9a34561f3909de40e64c8a26460b2/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return ((await Backendless.Data.of('DetailCategory').find(Backendless.DataQueryBuilder.create().setSortBy('name').setPageSize(50))).map(item => {; return ({ 'name': (item['name']),'oid': (item['oid']) });}))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/DetailEditPage/components/e8a9fce5faa414d33506667eb8bf0299/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('51a9a34561f3909de40e64c8a26460b2', '0');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/DetailEditPage/components/9022bbe2804a70b5dc073071c10cef4c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
      return (await Backendless.Data.of('Unit').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId is null or ','ownerId=\'',((await Backendless.UserService.getCurrentUser())['objectId']),'\''].join(''))).setSortBy('name').setPageSize(50)))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/DetailEditPage/components/e5862dd22ed94ac42468c39f7b946fa9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, value){ ___arguments.context.getComponentByUid(componentUid).value = value })('7c033f342edd05d618fc128d6b4ab212', '0');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/DetailEditPage/components/7c033f342edd05d618fc128d6b4ab212/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;



  return (await Backendless.Data.of('Unit').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId is null or ','ownerId = \'',((await Backendless.UserService.getCurrentUser())['objectId']),'\''].join(''))).setSortBy('name').setPageSize(100)))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/DetailEditPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['PageTitle'] = 'Produkt';
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b4252febd7039e2cfe29f04aa73d5d75', (await Backendless.Data.of('Detail').findById((getObjectProperty(___arguments.context.pageData, 'objectId')), )));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/DetailEditPage/components/133e7f15472a706a8eb3821bbf48a85e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('9022bbe2804a70b5dc073071c10cef4c')) != '') {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4252febd7039e2cfe29f04aa73d5d75'))['unitOid'] = (JSON.parse(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('9022bbe2804a70b5dc073071c10cef4c'))));
    } else {
      throw (new Error('Nie wybrano jednostki podstawowej!'))
    }
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('7c033f342edd05d618fc128d6b4ab212')) != '') {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4252febd7039e2cfe29f04aa73d5d75'))['multipackUnitOid'] = (JSON.parse(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('7c033f342edd05d618fc128d6b4ab212'))));
    }
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('51a9a34561f3909de40e64c8a26460b2')) != '') {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4252febd7039e2cfe29f04aa73d5d75'))['categoryOid'] = (JSON.parse(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('51a9a34561f3909de40e64c8a26460b2'))));
    }
    await Backendless.Data.of('Detail').save( ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('b4252febd7039e2cfe29f04aa73d5d75')) );
    (function () { window.history.back(); })();

  } catch (error) {
    (function (message) { alert(message) })((String('Błąd zapisu danych! ') + String(getObjectProperty(error, 'message'))));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DetailListPage/components/b8e210815cf50ef68181c84ebc2278e6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('DetailCategoryListPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/DetailListPage/components/8cb8a61c45f23214420f52f9dd15322b/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['objectId'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
  ___arguments.context.pageData['objectName'] = (getObjectProperty(___arguments.selectedRecord, 'name'));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/DetailListPage/components/0a2648ff82627fa1b2d344c757e5b1f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('UnitListPage', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/DetailListPage/components/fda34eb13a99a411ddbe9cb2a3965227/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, filePath, userExportPath;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    userExportPath = String('/export/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    filePath = (await Backendless.Files.saveFile(encodePath(userExportPath), 'Details.csv', 'text/plain', true));
    await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': (Backendless.getCurrentUserToken()) }})).send({ 'filePath': (String(userExportPath) + String('/Details.csv')),'tableName': 'Detail','tableOptions': ({ 'where': (await BackendlessUI.Functions.Custom['fn_0f429df91b0f40b5392b7d46e052a65a']()),'properties': ['objectId', 'name', 'identifier', 'ean', 'catalogNumber', 'multipackQuantity', 'price', 'vat'],'columnsMapping': undefined }),'csvOptions': ({ 'delimiter': ';','header': true,'quoted': true,'record_delimiter': 'windows' }) });
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(filePath, true, undefined);

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DetailListPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['PageTitle'] = 'Produkty';
  ___arguments.context.pageData['EditPageName'] = 'DetailEditPage';
  ___arguments.context.pageData['TableName'] = 'Detail';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/DistributorEditPage/components/8f14ba8285996f4a0683656111d79fb6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
      return (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId != \'',((await Backendless.UserService.getCurrentUser(false))['objectId']),'\''].join(''))).setSortBy('name').setPageSize(50)))

  },  
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/DistributorEditPage/components/4b28a7331908cbfb92177c45615d7e23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('8f14ba8285996f4a0683656111d79fb6', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DistributorEditPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['PageTitle'] = 'Dystrybutor';
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('ee6e8af85c8878e43de60e9fd38125cc', (await Backendless.Data.of('Contractor').findById((getObjectProperty(___arguments.context.pageData, 'objectId')), )));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('3a33553e50dc4f2811e36d97e3ce7d64', (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('ee6e8af85c8878e43de60e9fd38125cc')), 'orderFormat')));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/DistributorEditPage/components/f835663c33c8cce6a1a78fabbcf22142/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('8f14ba8285996f4a0683656111d79fb6')) != '') {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('ee6e8af85c8878e43de60e9fd38125cc'))['userOid'] = (JSON.parse(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('8f14ba8285996f4a0683656111d79fb6'))));
    }
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('ee6e8af85c8878e43de60e9fd38125cc'))['orderFormat'] = (JSON.parse(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('3a33553e50dc4f2811e36d97e3ce7d64'))));
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('ee6e8af85c8878e43de60e9fd38125cc'))['distributor'] = true;
    await Backendless.Data.of('Contractor').save( ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('ee6e8af85c8878e43de60e9fd38125cc')) );
    (function () { window.history.back(); })();

  } catch (error) {
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DistributorListPage/components/8cb8a61c45f23214420f52f9dd15322b/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['objectId'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
  ___arguments.context.pageData['objectName'] = (getObjectProperty(___arguments.selectedRecord, 'name'));

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
      return ([(await BackendlessUI.Functions.Custom['fn_0f429df91b0f40b5392b7d46e052a65a']()),' and ','distributor = true'].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/DistributorListPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['PageTitle'] = 'Dystrybutorzy';
  ___arguments.context.pageData['EditPageName'] = 'DistributorEditPage';
  ___arguments.context.pageData['TableName'] = 'Contractor';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/DocDetailsListPage/components/8cb8a61c45f23214420f52f9dd15322b/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['WhereClause'] = ([(await BackendlessUI.Functions.Custom['fn_0f429df91b0f40b5392b7d46e052a65a']()),' and created >=',(getObjectProperty(___arguments.context.pageData, 'dateFrom')),' and created <',(getObjectProperty(___arguments.context.pageData, 'dateTo')),(getObjectProperty(___arguments.context.pageData, 'userCondition')),(getObjectProperty(___arguments.context.pageData, 'contractorCondition')),(getObjectProperty(___arguments.context.pageData, 'contractor2Condition')),(getObjectProperty(___arguments.context.pageData, 'toSendCondition'))].join(''));

  return (getObjectProperty(___arguments.context.pageData, 'WhereClause'))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DocumentPage', ({ 'objectId': (getObjectProperty(___arguments.selectedRecord, 'documentId')) }));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/DocDetailsListPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var filterString;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  filterString = '';
  if ((getObjectProperty(___arguments.context.pageData, 'userOid')) != null) {
    ___arguments.context.pageData['userCondition'] = ([' and userOid=\'',(getObjectProperty(___arguments.context.pageData, 'userOid')),'\' '].join(''));
    filterString = String(filterString) + String(getObjectProperty(___arguments.context.pageData, 'fullName'));
  } else {
    ___arguments.context.pageData['userCondition'] = '';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'onlyToSend')) != null) {
    ___arguments.context.pageData['toSendCondition'] = (String(' and doNotSend = false') + String(' and sent = false'));
    filterString = String(filterString) + String('Nie wysłane');
  } else {
    ___arguments.context.pageData['toSendCondition'] = '';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'contractorObjectId')) != null) {
    ___arguments.context.pageData['contractorCondition'] = ([' and contractorObjectId=\'',(getObjectProperty(___arguments.context.pageData, 'contractorObjectId')),'\' '].join(''));
    filterString = String(filterString) + String(getObjectProperty(___arguments.context.pageData, 'contractorName'));
  } else {
    ___arguments.context.pageData['contractorCondition'] = '';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'contractor2ObjectId')) != null) {
    ___arguments.context.pageData['contractor2Condition'] = ([' and contractor2ObjectId=\'',(getObjectProperty(___arguments.context.pageData, 'contractor2ObjectId')),'\' '].join(''));
    filterString = String(filterString) + String(getObjectProperty(___arguments.context.pageData, 'contractor2Name'));
  } else {
    ___arguments.context.pageData['contractor2Condition'] = '';
  }
  ___arguments.context.pageData['filterString'] = filterString;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c419c8685aee7b52061e942ddea88571', (filterString.length > 0));
  ___arguments.context.pageData['dateFrom'] = ((await BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902']((new Date()))).valueOf());
  ___arguments.context.pageData['dateTo'] = ((await BackendlessUI.Functions.Custom['fn_e79d01550639771aff59ff8862a7dc4c']((new Date()))).valueOf());
  ___arguments.context.pageData['PageTitle'] = 'Pozycje dokumentów';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/DocDetailsListPage/components/c419c8685aee7b52061e942ddea88571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['filterString'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/DocDetailsListPage/components/f7eb17a8cfbc08b64e1a2b71eece4c41/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, filePath, userExportPath;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    userExportPath = String('/export/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    filePath = (await Backendless.Files.saveFile(encodePath(userExportPath), 'Documents.csv', 'text/plain', true));
    await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': (Backendless.getCurrentUserToken()) }})).send({ 'filePath': (String(userExportPath) + String('/Documents.csv')),'tableName': 'DocumentsExportView','tableOptions': ({ 'where': (getObjectProperty(___arguments.context.pageData, 'WhereClause')),'sortBy': 'Data','properties': undefined,'excludeProps': ['ownerId', 'created', 'documentId'],'relations': undefined,'columnsMapping': undefined,'pageSize': 1000 }),'csvOptions': ({ 'delimiter': ';','header': true,'quoted': false,'quoted_string': true }) });
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(filePath, true, undefined);

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DocDetailsListPage/components/a2f2634f03b192436f834c438bff9fc7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('8cb8a61c45f23214420f52f9dd15322b');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DocumentListPage/components/8cb8a61c45f23214420f52f9dd15322b/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DocumentPage', ({ 'objectId': (getObjectProperty(___arguments.selectedRecord, 'objectId')) }));

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['WhereClause'] = ([(await BackendlessUI.Functions.Custom['fn_0f429df91b0f40b5392b7d46e052a65a']()),' and created >=',(getObjectProperty(___arguments.context.pageData, 'dateFrom')),' and created <',(getObjectProperty(___arguments.context.pageData, 'dateTo')),(getObjectProperty(___arguments.context.pageData, 'userCondition')),(getObjectProperty(___arguments.context.pageData, 'contractorCondition')),(getObjectProperty(___arguments.context.pageData, 'contractor2Condition')),(getObjectProperty(___arguments.context.pageData, 'toSendCondition'))].join(''));

  return (getObjectProperty(___arguments.context.pageData, 'WhereClause'))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/DocumentListPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var filterString;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['PageTitle'] = 'Dokumenty';
  filterString = '';
  if ((getObjectProperty(___arguments.context.pageData, 'userOid')) != null) {
    ___arguments.context.pageData['userCondition'] = ([' and userOid=\'',(getObjectProperty(___arguments.context.pageData, 'userOid')),'\' '].join(''));
    filterString = String(filterString) + String(getObjectProperty(___arguments.context.pageData, 'fullName'));
  } else {
    ___arguments.context.pageData['userCondition'] = '';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'onlyToSend')) != null) {
    ___arguments.context.pageData['toSendCondition'] = (String(' and doNotSend = false') + String(' and sent = false'));
    filterString = String(filterString) + String('Nie wysłane');
  } else {
    ___arguments.context.pageData['toSendCondition'] = '';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'contractorObjectId')) != null) {
    ___arguments.context.pageData['contractorCondition'] = ([' and contractorObjectId=\'',(getObjectProperty(___arguments.context.pageData, 'contractorObjectId')),'\' '].join(''));
    filterString = String(filterString) + String(getObjectProperty(___arguments.context.pageData, 'contractorName'));
  } else {
    ___arguments.context.pageData['contractorCondition'] = '';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'contractor2ObjectId')) != null) {
    ___arguments.context.pageData['contractor2Condition'] = ([' and contractor2ObjectId=\'',(getObjectProperty(___arguments.context.pageData, 'contractor2ObjectId')),'\' '].join(''));
    filterString = String(filterString) + String(getObjectProperty(___arguments.context.pageData, 'contractor2Name'));
  } else {
    ___arguments.context.pageData['contractor2Condition'] = '';
  }
  ___arguments.context.pageData['filterString'] = filterString;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c419c8685aee7b52061e942ddea88571', (filterString.length > 0));
  ___arguments.context.pageData['dateFrom'] = ((await BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902']((new Date()))).valueOf());
  ___arguments.context.pageData['dateTo'] = ((await BackendlessUI.Functions.Custom['fn_e79d01550639771aff59ff8862a7dc4c']((new Date()))).valueOf());

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/DocumentListPage/components/c419c8685aee7b52061e942ddea88571/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.pageData['filterString'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/DocumentListPage/components/f7eb17a8cfbc08b64e1a2b71eece4c41/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, filePath, userExportPath;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    userExportPath = String('/export/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    filePath = (await Backendless.Files.saveFile(encodePath(userExportPath), 'Documents.csv', 'text/plain', true));
    await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': (Backendless.getCurrentUserToken()) }})).send({ 'filePath': (String(userExportPath) + String('/Documents.csv')),'tableName': 'DocumentsExportView','tableOptions': ({ 'where': (getObjectProperty(___arguments.context.pageData, 'WhereClause')),'sortBy': 'Data','properties': undefined,'excludeProps': ['ownerId', 'created'],'relations': undefined,'columnsMapping': undefined,'pageSize': 1000 }),'csvOptions': ({ 'delimiter': ';','header': true,'quoted': false,'quoted_string': true }) });
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(filePath, true, undefined);

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DocumentListPage/components/a2f2634f03b192436f834c438bff9fc7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('8cb8a61c45f23214420f52f9dd15322b');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DocumentPage/components/d8d31f67534f6c06ebf5f2ed1b916322/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  onWhereClauseAssignment(___arguments) {
      return (['documentObjectId = \'',(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['objectId']),'\''].join(''))

  },  
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/DocumentPage/components/bb713a741dff4a3541fac8d6c9ea9b02/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['defDocumentName']),' ',(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['number'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/DocumentPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['PageTitle'] = 'Dokument';
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('f9afddb89178b1824b4dc381f6a4cf7b', ((await Backendless.Data.of('DocumentView').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'objectId')),'\''].join(''))).setPageSize(1)))[0]));

  } catch (error) {
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/DocumentPage/components/3ad370ac6a1828b3d9d77cea219bc266/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['notes'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/DocumentPage/components/eaac318d7324315251828ee4444a3a5b/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  onCheckedStateAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['doNotSend'])

  },  
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/DocumentPage/components/2239fcfd19e51ab27069b059a69d15b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b'), 'contractorName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/DocumentPage/components/615857843b177a049f3a97933a812346/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b'), 'contractor2Name'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/DocumentPage/components/cf872e0567b3a23ba1e37847530e7546/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['streetAndNumber'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/DocumentPage/components/27946d7590a23e6e91c58f321f684525/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['cityAndZip'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/DocumentPage/components/051f95b6038b1d7835f75c2854373b3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b'), 'priceNet'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/DocumentPage/components/b7793c994ea6e4f5c919d12b573a0b7e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b'), 'priceGross'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/DocumentPage/components/aa028d5c1a276b63265baee82b2fb40b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f9afddb89178b1824b4dc381f6a4cf7b')), 'position')) != null)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('MapPage', ({ 'contractorId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b'), 'contractorObjectId')),'documentId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/DocumentPage/components/073e587ef02f5787b3f3efa54c1e952d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b'), 'created')) != null ? [((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b'), 'created')))).toLocaleDateString()),' ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b'), 'created')))).toLocaleTimeString())].join('') : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/DocumentPage/components/851da9196ba36b12fd4733bb650233ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b'), 'createdOnDevice')) != null ? [((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b'), 'createdOnDevice')))).toLocaleDateString()),' ',((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b'), 'createdOnDevice')))).toLocaleTimeString())].join('') : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/ForgotPasswordPage/components/4641c8cb6f0597610bb5b1fce8828044/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.restorePassword((___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['emailInput']))

  },  
/* handler:onClick *//* content */
}));

define('./pages/MapPage/components/bb713a741dff4a3541fac8d6c9ea9b02/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ([(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['defDocumentName']),' ',(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['number'])].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/MapPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, points;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    ___arguments.context.pageData['PageTitle'] = 'Mapa';
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('f9afddb89178b1824b4dc381f6a4cf7b', ((await Backendless.Data.of('DocumentView').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'documentId')),'\''].join(''))).setPageSize(1)))[0]));
    if ((getObjectProperty(___arguments.context.pageData, 'contractorId')) != null) {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('9fdbeecf4cf77e6fb26c1e757175b68e', ((await Backendless.Data.of('Contractor').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(___arguments.context.pageData, 'contractorId')),'\''].join(''))).setPageSize(1)))[0]));
    }
    points = [];
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f9afddb89178b1824b4dc381f6a4cf7b')), 'position')) != null) {
      addItemToList(points, ({ 'title': [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f9afddb89178b1824b4dc381f6a4cf7b')), 'number')),'<br/>',((new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f9afddb89178b1824b4dc381f6a4cf7b')), 'createdOnDevice')))).toLocaleDateString()),' ',((new Date((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f9afddb89178b1824b4dc381f6a4cf7b')), 'createdOnDevice')))).toLocaleTimeString()),'<br/>',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f9afddb89178b1824b4dc381f6a4cf7b')), 'userName'))].join(''),'lat': (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f9afddb89178b1824b4dc381f6a4cf7b')), 'position')), 'lat')),'lng': (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f9afddb89178b1824b4dc381f6a4cf7b')), 'position')), 'lng')),'position': undefined,'icon': ({ 'url': 'https://maps.google.com/mapfiles/kml/pal3/icon26.png' }) }));
    }
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('9fdbeecf4cf77e6fb26c1e757175b68e')), 'location')) != null) {
      addItemToList(points, ({ 'title': [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('9fdbeecf4cf77e6fb26c1e757175b68e')), 'name')),'<br/>',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('9fdbeecf4cf77e6fb26c1e757175b68e')), 'streetAndNumber')),'<br/>',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('9fdbeecf4cf77e6fb26c1e757175b68e')), 'cityAndZip'))].join(''),'lat': (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('9fdbeecf4cf77e6fb26c1e757175b68e')), 'location')), 'lat')),'lng': (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('9fdbeecf4cf77e6fb26c1e757175b68e')), 'location')), 'lng')) }));
    }
    if (!!points.length) {
      (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('a9198bae0bd618a3d364c64758bbb2f3', points);
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('a9198bae0bd618a3d364c64758bbb2f3', (getObjectProperty((points[0]), 'lat')), (getObjectProperty((points[0]), 'lng')));
      (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('a9198bae0bd618a3d364c64758bbb2f3', 11);
    }

  } catch (error) {
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/PasswordRecoveryPage/components/4641c8cb6f0597610bb5b1fce8828044/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.restorePassword((___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172')['emailInput']))

  },  
/* handler:onClick *//* content */
}));

define('./pages/RetailChainListPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['PageTitle'] = 'Sieci sklepów';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/RetailChainListPage/components/003892cb9004515cd7def7562c77505e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/RetailChainListPage/components/975fd35bb5cce2de28eff703a7463858/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('home', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/SalesmanEditPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['PageTitle'] = 'Handlowiec';
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('7308e85e2cc6aabe7a2c9a79c407dd94', (
      await Backendless.Data.of( Backendless.User ).findById((getObjectProperty(___arguments.context.pageData, 'objectId')))
  ));
  ___arguments.context.pageData['password1'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7308e85e2cc6aabe7a2c9a79c407dd94')), 'password'));
  ___arguments.context.pageData['password2'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7308e85e2cc6aabe7a2c9a79c407dd94')), 'password'));

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/SalesmanEditPage/components/18a731eb690fd363389c6ffa3e611a55/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function checkPassword() {
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7308e85e2cc6aabe7a2c9a79c407dd94')), 'password1')) == null) {
    throw (new Error('Wprowadź hasło.'))
  } else if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7308e85e2cc6aabe7a2c9a79c407dd94')), 'password1')).length) {
    throw (new Error('Wprowadź hasło.'))
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7308e85e2cc6aabe7a2c9a79c407dd94')), 'password1')).length < 8) {
    throw (new Error('Hasło musi składać się z co najmniej 8 znaków'))
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7308e85e2cc6aabe7a2c9a79c407dd94')), 'password1')) != (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7308e85e2cc6aabe7a2c9a79c407dd94')), 'password2'))) {
    throw (new Error('Podane hasła są różne!'))
  }
}


  try {
    if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7308e85e2cc6aabe7a2c9a79c407dd94')), 'setPassword')) {
      await checkPassword();
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7308e85e2cc6aabe7a2c9a79c407dd94'))['password'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7308e85e2cc6aabe7a2c9a79c407dd94')), 'password1'));
    }
    await Backendless.UserService.update( new Backendless.User(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7308e85e2cc6aabe7a2c9a79c407dd94'))) );
    (function () { window.history.back(); })();

  } catch (error) {
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/SalesmanListPage/components/8cb8a61c45f23214420f52f9dd15322b/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['objectId'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
  ___arguments.context.pageData['objectName'] = (getObjectProperty(___arguments.selectedRecord, 'fullName'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9afddb89178b1824b4dc381f6a4cf7b', ((getObjectProperty(___arguments.context.pageData, 'editMode')) == true));

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
      return ([(await BackendlessUI.Functions.Custom['fn_0f429df91b0f40b5392b7d46e052a65a']()),' and ','ownerId != objectId'].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/SalesmanListPage/components/5f968c36d978652669b99cab8a53954a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error;


  try {
    await Backendless.UserService.update( new Backendless.User(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')) );
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9afddb89178b1824b4dc381f6a4cf7b', false);
    ___arguments.context.pageData['statusMessage'] = '';

  } catch (error) {
    ___arguments.context.pageData['statusMessage'] = (String('Błąd zapisu danych! ') + String(error['message']));

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/SalesmanListPage/components/09bb104a6af71d0f48ec681abc2d4fd3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9afddb89178b1824b4dc381f6a4cf7b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/SalesmanListPage/components/fd4930a5132b1e3c0fc1074b24859ead/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('041f75b9a3e57682a1652d12c1ab27d3', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/SalesmanListPage/components/6f6a411a2b73f9f94e430f4466164562/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('041f75b9a3e57682a1652d12c1ab27d3', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/SalesmanListPage/components/c40517e940fb455c47b6f938796c29d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error;


  try {
    await Backendless.Data.of(Backendless.User).remove({ objectId: (___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['objectId']) })
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9afddb89178b1824b4dc381f6a4cf7b', false);

  } catch (error) {
    ___arguments.context.pageData['statusMessage'] = (String('Błąd usuwania danych! ') + String(error['message']));

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/SalesmanListPage/components/7dac86d5a99ff61d0e2c76f2b42afd28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error;

/**
 * Describe this function...
 */
async function checkPassword() {
  if ((___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['password1']) == null) {
    throw (new Error('Wprowadź hasło.'))
  } else if (!(___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['password1']).length) {
    throw (new Error('Wprowadź hasło.'))
  } else if ((___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['password1']).length < 8) {
    throw (new Error('Hasło musi składać się z co najmniej 8 znaków'))
  } else if ((___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['password1']) != (___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['password2'])) {
    throw (new Error('Podane hasła są różne!'))
  }
}


  try {
    await checkPassword();
    ___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['password'] = (___arguments.context.getComponentDataStoreByUid('f9afddb89178b1824b4dc381f6a4cf7b')['password1']);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('46cf950a6a4c0bd89a8baa1f6d7e7ada', false);
    ___arguments.context.pageData['statusMessage'] = '';

  } catch (error) {
    ___arguments.context.pageData['statusMessage'] = (error['message']);

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/SalesmanListPage/components/3cccb5454f463b7f3842477f13dfece7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('46cf950a6a4c0bd89a8baa1f6d7e7ada', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/SalesmanListPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['PageTitle'] = 'Handlowcy';
  ___arguments.context.pageData['EditPageName'] = 'SalesmanEditPage';
  ___arguments.context.pageData['TableName'] = 'Users';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/StatsDetailsPage/components/003892cb9004515cd7def7562c77505e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/StatsDetailsPage/components/d46532123826c45f7f41d5f32a7a5ca3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var DateSpanString, error;

/**
 * Describe this function...
 */
async function getDates(DateSpanString) {
  if (DateSpanString == 'ThisWeek') {
    return (String('created >=') + String((await BackendlessUI.Functions.Custom['fn_3e6beb363a8e0bbdd1ed31ed14c87a32']((new Date()))).valueOf()));
  } else if (DateSpanString == 'LastWeek') {
    return (['created >=',((await BackendlessUI.Functions.Custom['fn_3e6beb363a8e0bbdd1ed31ed14c87a32']((new Date((new Date()).getTime() - (604800 * 1000))))).valueOf()),' and created <',((await BackendlessUI.Functions.Custom['fn_3e6beb363a8e0bbdd1ed31ed14c87a32']((new Date()))).valueOf())].join(''));
  } else if (DateSpanString == 'ThisMonth') {
    return (String('created >=') + String((await BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902']((new Date()))).valueOf()));
  } else if (DateSpanString == 'LastMonth') {
    return (['created >=',((await BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902']((new Date((await BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902']((new Date()))).getTime() - (100 * 1000))))).valueOf()),' and created <',((await BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902']((new Date()))).valueOf())].join(''));
  } else if (DateSpanString == 'ThisYear') {
    return (String('created >=') + String((await BackendlessUI.Functions.Custom['fn_3ad9debeb7cf366b6934759314acad42']((new Date()))).valueOf()));
  } else if (DateSpanString == 'LastYear') {
    return (['created >=',((await BackendlessUI.Functions.Custom['fn_3ad9debeb7cf366b6934759314acad42']((new Date((await BackendlessUI.Functions.Custom['fn_3ad9debeb7cf366b6934759314acad42']((new Date()))).getTime() - (86400 * 1000))))).valueOf()),' and created <',((await BackendlessUI.Functions.Custom['fn_3ad9debeb7cf366b6934759314acad42']((new Date()))).valueOf())].join(''));
  } else if (DateSpanString == 'Yesterday') {
    return (['created >=',((await BackendlessUI.Functions.Custom['fn_6ebfa9a178c57e29fccbf797ecd8546d']((new Date((new Date()).getTime() - (86400 * 1000))))).valueOf()),' and created <',((await BackendlessUI.Functions.Custom['fn_6ebfa9a178c57e29fccbf797ecd8546d']((new Date()))).valueOf())].join(''));
  } else {
  }
  return String(' created > ') + String((await BackendlessUI.Functions.Custom['fn_6ebfa9a178c57e29fccbf797ecd8546d']((new Date()))).valueOf())
}

/**
 * Describe this function...
 */
async function GetWhereClause() {
  return [(await BackendlessUI.Functions.Custom['fn_0f429df91b0f40b5392b7d46e052a65a']()),' and ',(await BackendlessUI.Functions.Custom['fn_5dcffceba15f6708c8eba19bbf187e8f'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('16b91a0238cc212bd0b8da6d276e69ce')))),' and (',await GetSearchWhereClause(),')'].join('')
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function GetSearchWhereClause() {
  return [' productName like \'%',(getObjectProperty(___arguments.context.pageData, 'searchProduct')),'%\' and  distributorName like \'%',(getObjectProperty(___arguments.context.pageData, 'searchDistributor')),'%\' and  contractorName like \'%',(getObjectProperty(___arguments.context.pageData, 'searchContractor')),'%\''].join('')
}


  try {
    ___arguments.context.pageData['WhereClause'] = (await GetWhereClause());
    ___arguments.context.pageData['PageSize'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('164b5a9ddfec8ea97611a5ba7e04ba02'));
    ___arguments.context.pageData['PageNo'] = 1;
    ___arguments.context.pageData['PageOffset'] = 0;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('443d1682a3e57255f17c730f3502cf34', (await Backendless.Data.of('DocDetailStatsView').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'WhereClause'))).setSortBy('created asc').setPageSize((getObjectProperty(___arguments.context.pageData, 'PageSize'))).setOffset((getObjectProperty(___arguments.context.pageData, 'PageOffset'))))));

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/StatsDetailsPage/components/28b6ae86ded890a8d49b75b7f947cc7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('297e5d49c6347063e8a7eac1c1995a77'), 'created')))).toLocaleDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/StatsDetailsPage/components/09c8832302bc84b6b2780d5be3c89913/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['PageNo'] = (await BackendlessUI.Functions.Custom['fn_2876227199e4c3f6970141db38fe155a']((getObjectProperty(___arguments.context.pageData, 'PageNo'))));
  ___arguments.context.pageData['PageOffset'] = ((await BackendlessUI.Functions.Custom['fn_f315d0987625e6df48afb5dfc7c5187f']((getObjectProperty(___arguments.context.pageData, 'PageNo')), null)) * (getObjectProperty(___arguments.context.pageData, 'PageSize')));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('443d1682a3e57255f17c730f3502cf34', (await Backendless.Data.of('DocDetailStatsView').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'WhereClause'))).setSortBy('created asc').setPageSize((getObjectProperty(___arguments.context.pageData, 'PageSize'))).setOffset((getObjectProperty(___arguments.context.pageData, 'PageOffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/StatsDetailsPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['PageNo'] = 1;
  ___arguments.context.pageData['PageOffset'] = 0;
  ___arguments.context.pageData['PageSize'] = 50;
  ___arguments.context.pageData['PageCount'] = 1;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/StatsDetailsPage/components/4fa1d2672b7f57c221aa43117a099278/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['PageNo'] = (await BackendlessUI.Functions.Custom['fn_f315d0987625e6df48afb5dfc7c5187f']((getObjectProperty(___arguments.context.pageData, 'PageNo')), 1));
  ___arguments.context.pageData['PageOffset'] = (((getObjectProperty(___arguments.context.pageData, 'PageNo')) - 1) * (getObjectProperty(___arguments.context.pageData, 'PageSize')));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('443d1682a3e57255f17c730f3502cf34', (await Backendless.Data.of('DocDetailStatsView').find(Backendless.DataQueryBuilder.create().setWhereClause((getObjectProperty(___arguments.context.pageData, 'WhereClause'))).setSortBy('created asc').setPageSize((getObjectProperty(___arguments.context.pageData, 'PageSize'))).setOffset((getObjectProperty(___arguments.context.pageData, 'PageOffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/StatsDetailsPage/components/28836418c8b69b9fe801ea4b9c6b057d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'PageNo'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/StatsDetailsPage/components/48db004e2dd569f4323a4a6c1dd2f1c9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/StatsDetailsPage/components/4c0e04b3d323a963fc2303b79854eec7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, filePath, userExportPath, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    userExportPath = String('/export/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'));
    filePath = (await Backendless.Files.saveFile(encodePath(userExportPath), 'Sprzedaż.csv', 'text/plain', true));
    await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (String(userExportPath) + String('/Sprzedaż.csv')),'tableName': 'Contractor','tableOptions': ({ 'where': undefined,'properties': undefined,'columnsMapping': undefined }),'csvOptions': ({ 'delimiter': ';','header': true,'record_delimiter': 'windows' }) });
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(filePath, true, undefined);

  } catch (error) {
    (function (message) { alert(message) })(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/StatsDetailsPage/components/3ebdc0a9df07c1c689b878c858c4d431/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_902fc5739ffa39dff8de66e4d73ddbe2']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('297e5d49c6347063e8a7eac1c1995a77'), 'valueNet'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/StatsDetailsPage/components/236937a83be7e31d79a126c543ca3096/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_902fc5739ffa39dff8de66e4d73ddbe2']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('297e5d49c6347063e8a7eac1c1995a77'), 'valueGross'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/StatsPage/components/d46532123826c45f7f41d5f32a7a5ca3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function getTableName() {
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fadbeb4b127308d584134f937a897db2')) == 'Detail') {
    return 'ProductView';
  }
  return 'DocumentView'
}

/**
 * Describe this function...
 */
async function descField() {
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fadbeb4b127308d584134f937a897db2')) == 'Salesman') {
    return 'userName';
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fadbeb4b127308d584134f937a897db2')) == 'Distributor') {
    return 'contractor2Name';
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fadbeb4b127308d584134f937a897db2')) == 'Contractor') {
    return 'contractorName';
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('fadbeb4b127308d584134f937a897db2')) == 'Detail') {
    return 'detailName';
  }
  return 'userName'
}

/**
 * Describe this function...
 */
async function getSort() {
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c42d65f273d8c5e8f5cd36e8293a380a')) == 'PriceDesc') {
    return 'price desc';
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c42d65f273d8c5e8f5cd36e8293a380a')) == 'CounterDesc') {
    return 'counter desc';
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c42d65f273d8c5e8f5cd36e8293a380a')) == 'PriceAsc') {
    return 'price asc';
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c42d65f273d8c5e8f5cd36e8293a380a')) == 'CounterAsc') {
    return 'counter asc';
  }
  return 'price desc'
}

/**
 * Describe this function...
 */
async function getDates() {
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('16b91a0238cc212bd0b8da6d276e69ce')) == 'ThisWeek') {
    return (String('created >=') + String((await BackendlessUI.Functions.Custom['fn_3e6beb363a8e0bbdd1ed31ed14c87a32']((new Date()))).valueOf()));
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('16b91a0238cc212bd0b8da6d276e69ce')) == 'LastWeek') {
    return (['created >=',((await BackendlessUI.Functions.Custom['fn_3e6beb363a8e0bbdd1ed31ed14c87a32']((new Date((new Date()).getTime() - (604800 * 1000))))).valueOf()),' and created <',((await BackendlessUI.Functions.Custom['fn_3e6beb363a8e0bbdd1ed31ed14c87a32']((new Date()))).valueOf())].join(''));
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('16b91a0238cc212bd0b8da6d276e69ce')) == 'ThisMonth') {
    return (String('created >=') + String((await BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902']((new Date()))).valueOf()));
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('16b91a0238cc212bd0b8da6d276e69ce')) == 'LastMonth') {
    return (['created >=',((await BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902']((new Date((await BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902']((new Date()))).getTime() - (100 * 1000))))).valueOf()),' and created <',((await BackendlessUI.Functions.Custom['fn_8859944ac853b1011ca3f8faa8de9902']((new Date()))).valueOf())].join(''));
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('16b91a0238cc212bd0b8da6d276e69ce')) == 'ThisYear') {
    return (String('created >=') + String((await BackendlessUI.Functions.Custom['fn_3ad9debeb7cf366b6934759314acad42']((new Date()))).valueOf()));
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('16b91a0238cc212bd0b8da6d276e69ce')) == 'LastYear') {
    return (['created >=',((await BackendlessUI.Functions.Custom['fn_3ad9debeb7cf366b6934759314acad42']((new Date((await BackendlessUI.Functions.Custom['fn_3ad9debeb7cf366b6934759314acad42']((new Date()))).getTime() - (86400 * 1000))))).valueOf()),' and created <',((await BackendlessUI.Functions.Custom['fn_3ad9debeb7cf366b6934759314acad42']((new Date()))).valueOf())].join(''));
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('16b91a0238cc212bd0b8da6d276e69ce')) == 'Yesterday') {
    return (['created >=',((await BackendlessUI.Functions.Custom['fn_6ebfa9a178c57e29fccbf797ecd8546d']((new Date((new Date()).getTime() - (86400 * 1000))))).valueOf()),' and created <',((await BackendlessUI.Functions.Custom['fn_6ebfa9a178c57e29fccbf797ecd8546d']((new Date()))).valueOf())].join(''));
  } else {
  }
  return String(' created > ') + String((await BackendlessUI.Functions.Custom['fn_6ebfa9a178c57e29fccbf797ecd8546d']((new Date()))).valueOf())
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('443d1682a3e57255f17c730f3502cf34', (await Backendless.Data.of((await getTableName())).find(Backendless.DataQueryBuilder.create().setWhereClause(([(await BackendlessUI.Functions.Custom['fn_0f429df91b0f40b5392b7d46e052a65a']()),' and ',await getDates(),' and ',await descField(),' is not null'].join(''))).setProperties(([await descField(),' as description',', sum(priceNet) as price',', count(objectId) as counter'].join(''))).setSortBy((await getSort())).setGroupBy((await descField())).setPageSize(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('164b5a9ddfec8ea97611a5ba7e04ba02'))))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf9749494582f69887e1efb7b648c463', true);
  if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('443d1682a3e57255f17c730f3502cf34')).length) {
    ___arguments.context.pageData['infoMessage'] = 'Pusta lista';
    ___arguments.context.pageData['sumPrice'] = '0';
    ___arguments.context.pageData['sumCounter'] = '0';
  } else {
    ___arguments.context.pageData['infoMessage'] = '';
    ___arguments.context.pageData['sumPrice'] = ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('443d1682a3e57255f17c730f3502cf34')).map(async item => {; return (getObjectProperty(item, 'price'));}))).reduce(function(x, y) {return x + y;}));
    ___arguments.context.pageData['sumCounter'] = ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('443d1682a3e57255f17c730f3502cf34')).map(async item => {; return (getObjectProperty(item, 'counter'));}))).reduce(function(x, y) {return x + y;}));
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('443d1682a3e57255f17c730f3502cf34', (!!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('443d1682a3e57255f17c730f3502cf34')).length));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9fb7c33ac153c4e8a264ad6fe016409b', ((getObjectProperty(___arguments.context.pageData, 'infoMessage')).length > 0));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/StatsPage/components/3ebdc0a9df07c1c689b878c858c4d431/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_bbeb8b6e187dd40a2cffcfa716af6865']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('297e5d49c6347063e8a7eac1c1995a77'), 'price'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/StatsPage/components/af0fefc48d941491631db85c0cda830f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_bbeb8b6e187dd40a2cffcfa716af6865']((getObjectProperty(___arguments.context.pageData, 'sumPrice'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/StatsPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['PageTitle'] = 'Statystyki';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/UnitListPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  ['onBeforeEnter'](___arguments) {
      ___arguments.context.pageData['PageTitle'] = 'Jednostki';

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/UnitListPage/components/80f40ba1d51fae34b1e2add69bcd1cf5/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async onWhereClauseAssignment(___arguments) {
      return (['ownerId is null or ','ownerId=\'',((await Backendless.UserService.getCurrentUser(false))['objectId']),'\''].join(''))

  },  
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/UserAccountPage/components/5f968c36d978652669b99cab8a53954a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await Backendless.UserService.update( new Backendless.User(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7696720fccfe046cc5f424719c93affd'))) );
    ___arguments.context.pageData['statusMessage'] = 'Dane zostały zapisane';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5a9166d1568c716b61889d49525154d7'))['background-color'] = '#00ff00';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a9166d1568c716b61889d49525154d7', true);

  } catch (error) {
    ___arguments.context.pageData['statusMessage'] = (String('Błąd zapisu danych! ') + String(getObjectProperty(error, 'message')));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5a9166d1568c716b61889d49525154d7'))['background-color'] = '#ff0000';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a9166d1568c716b61889d49525154d7', true);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/UserAccountPage/components/09bb104a6af71d0f48ec681abc2d4fd3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f9afddb89178b1824b4dc381f6a4cf7b', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/UserAccountPage/components/7dac86d5a99ff61d0e2c76f2b42afd28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function checkPassword() {
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7696720fccfe046cc5f424719c93affd')), 'password1')) == null) {
    throw (new Error('Wprowadź hasło.'))
  } else if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7696720fccfe046cc5f424719c93affd')), 'password1')).length) {
    throw (new Error('Wprowadź hasło.'))
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7696720fccfe046cc5f424719c93affd')), 'password1')).length < 8) {
    throw (new Error('Hasło musi składać się z co najmniej 8 znaków'))
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7696720fccfe046cc5f424719c93affd')), 'password1')) != (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7696720fccfe046cc5f424719c93affd')), 'password2'))) {
    throw (new Error('Podane hasła są różne!'))
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5a9166d1568c716b61889d49525154d7', true);
  try {
    await checkPassword();
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7696720fccfe046cc5f424719c93affd'))['password'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('7696720fccfe046cc5f424719c93affd')), 'password1'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('46cf950a6a4c0bd89a8baa1f6d7e7ada', false);
    ___arguments.context.pageData['statusMessage'] = 'Hasło zostało zmienione. Zapisz zmiany!';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5a9166d1568c716b61889d49525154d7'))['background-color'] = '00b400';

  } catch (error) {
    ___arguments.context.pageData['statusMessage'] = (getObjectProperty(error, 'message'));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5a9166d1568c716b61889d49525154d7'))['background-color'] = '#ff0000';

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/UserAccountPage/components/3cccb5454f463b7f3842477f13dfece7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('46cf950a6a4c0bd89a8baa1f6d7e7ada', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/UserAccountPage/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      ___arguments.context.pageData['PageTitle'] = 'Twoje konto';
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('7696720fccfe046cc5f424719c93affd', (await Backendless.UserService.getCurrentUser(false)));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('bb7f9f8fa40a55e7ed441cb883bf505a', (await Backendless.UserService.getCurrentUser(false)));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/UserAccountPage/components/757a799a32bb6f33b07cd8ce88034d8b/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
      return ((new Date((___arguments.context.getComponentDataStoreByUid('bb7f9f8fa40a55e7ed441cb883bf505a')['licenseValidDate']))).toLocaleDateString())

  },  
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/UserAccountPage/components/e252aa9d85522b4be4151708ae48bb52/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(await BackendlessUI.Functions.Custom['fn_f315d0987625e6df48afb5dfc7c5187f']((await Backendless.Data.of('Users').getObjectCount()), 0)),' / ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bb7f9f8fa40a55e7ed441cb883bf505a'), 'licenseSalesmansQuantity'))].join(''))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/UserAccountPage/components/60bf02f24ccc468bf9ef4abe5e581253/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLoginPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/UserLoginPage/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var user, error, password, username, stayLoggedIn, logging, buttonLogin;

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.UserService.login( username, password, stayLoggedIn  ));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}

/**
 * Describe this function...
 */
async function updateButtonLogin(logging) {
  buttonLogin = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  buttonLogin['label'] = (logging ? 'Czekaj...' : 'Zaloguj');
  buttonLogin['disabled'] = logging;
}


  await setError(null);
  username = (___arguments.context.dataModel['username']);
  password = (___arguments.context.dataModel['password']);
  stayLoggedIn = (___arguments.context.dataModel['stayLoggedIn']);
  if (username && password) {
    await updateButtonLogin(true);
    try {
      await login();
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('home', null);

    } catch (error) {
      if ((error['code']) == 3033) {
        await login();
      } else {
        await setError(error);
      }

    } finally {
      await updateButtonLogin(false);

    }
  } else {
    await setError((new Error('Wprowadź nazwę użytkownika i hasło.')));
  }
  if (user) {
    ___arguments.context.appData['currentUser'] = user;
  }

  },  
  /* handler:onSubmit *//* content */
}));

define('./pages/UserLoginPageAAA/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var user, error, password, username, stayLoggedIn, logging, buttonLogin;

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.UserService.login( username, password, false  ));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}

/**
 * Describe this function...
 */
async function updateButtonLogin(logging) {
  buttonLogin = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  buttonLogin['label'] = (logging ? 'Please wait...' : 'Login');
  buttonLogin['disabled'] = logging;
}


  await setError(null);
  username = (___arguments.context.dataModel['username']);
  password = (___arguments.context.dataModel['password']);
  stayLoggedIn = (___arguments.context.dataModel['stayLoggedIn']);
  if (username && password) {
    await updateButtonLogin(true);
    try {
      await login();

    } catch (error) {
      if ((error['code']) == 3033) {
        await login();
      } else {
        await setError(error);
      }

    } finally {
      await updateButtonLogin(false);

    }
  } else {
    await setError((new Error('Username and Password must be filled')));
  }
  if (user) {
    ___arguments.context.appData['currentUser'] = user;
  }

  },  
/* handler:onSubmit *//* content */
}));

define('./pages/UserLoginPageAAA/components/a16f5df2d21fe78354f37b2c25db4781/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var error;


  ___arguments.context.pageData['statusMessage'] = '';
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2b01eaaf58b717b2f475981400819b99'))['background-color'] = '#ff0000';
  try {
    await Backendless.UserService.login( (___arguments.context.pageData['username']), (___arguments.context.pageData['password']), true  );
    ___arguments.context.pageData['statusMessage'] = 'Witaj!';
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2b01eaaf58b717b2f475981400819b99'))['background-color'] = '#00ff00';

  } catch (error) {
    ___arguments.context.pageData['statusMessage'] = (String('Błąd logowania!') + String(error['message']));

  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/UserRegistrationPage/components/d09e084ab7f33d745be3f681c71e686d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function checkInputs() {
  if ((getObjectProperty(___arguments.context.pageData, 'password1')) == null) {
    throw (new Error('Wprowadź hasło.'))
  } else if (!(getObjectProperty(___arguments.context.pageData, 'password1')).length) {
    throw (new Error('Wprowadź hasło.'))
  } else if ((getObjectProperty(___arguments.context.pageData, 'password1')).length < 8) {
    throw (new Error('Hasło musi składać się z co najmniej 8 znaków'))
  } else if ((getObjectProperty(___arguments.context.pageData, 'password1')) != (getObjectProperty(___arguments.context.pageData, 'password2'))) {
    throw (new Error('Podane hasła są różne!'))
  } else if ((getObjectProperty(___arguments.context.pageData, 'termsAccepted')) != true) {
    throw (new Error('Zaznacz akceptację regulaminu!'))
  }
}


  ___arguments.context.pageData['statusMessage'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('092335ff99c54d2fc413339cd8e5a025'))['background-color'] = '#ff0000';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('092335ff99c54d2fc413339cd8e5a025', true);
  try {
    await checkInputs();
    await Backendless.UserService.register( new Backendless.User({ 'email': (getObjectProperty(___arguments.context.pageData, 'email')),'password': (getObjectProperty(___arguments.context.pageData, 'password1')),'name': (getObjectProperty(___arguments.context.pageData, 'name')),'licenseValidDate': (new Date((new Date()).getTime() + (604800 * 1000))) }) );
    ___arguments.context.pageData['statusMessage'] = 'Gratuluję! Sprawdź pocztę i potwierdź rejestrację.';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('092335ff99c54d2fc413339cd8e5a025'))['background-color'] = '#00ff00';
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLoginPage', undefined);

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 0) {
      ___arguments.context.pageData['statusMessage'] = 'Podany użytkownik jest już zarejestrowany w systemie!';
    } else {
      ___arguments.context.pageData['statusMessage'] = (String('Błąd! ') + String(getObjectProperty(error, 'message')));
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (await Backendless.UserService.isValidLogin()) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('90440556ff3edceab61f042d9e1bb787', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22b33bcae2ce62eaf9769e6968e24296', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('69cf22a2a5236ccf4c3e6fa4f5a3209b', false);
    ___arguments.context.pageData['helloUserText'] = (String('Witaj ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2eca1862570168c4b0e74704dbc8e386', ((await Backendless.UserService.getUserRoles()).includes('SuperAdmin')));
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('90440556ff3edceab61f042d9e1bb787', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22b33bcae2ce62eaf9769e6968e24296', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('69cf22a2a5236ccf4c3e6fa4f5a3209b', true);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLoginPage', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/home/components/cea55b3d0e994d41d4779581d567ca0c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const targetUrl = `${url}?${BackendlessUI.QueryString.stringify(params)}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://play.google.com/store/apps/details?id=pl.etinel.zamawiaj24', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/9c56f6b94787fdbc5a7bfecdf61b34c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await Backendless.Data.of('Document').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('created >') + String((await BackendlessUI.Functions.Custom['fn_6ebfa9a178c57e29fccbf797ecd8546d']((new Date()))).valueOf())))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/8236646ac5ceb982004afc4be3a9a24b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var result, item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('Document').find(Backendless.DataQueryBuilder.create().setWhereClause((String('created > ') + String((await BackendlessUI.Functions.Custom['fn_6ebfa9a178c57e29fccbf797ecd8546d']((new Date()))).valueOf()))).setProperties('sum(priceNet)').setGroupBy('ownerId').setPageSize(1)));
  if (!list.length) {
    result = '0';
  } else {
    result = (await Promise.all(list.map(async item => {; return (getObjectProperty(item, 'sum'));})));
  }

  return (await BackendlessUI.Functions.Custom['fn_01eb5f7ce622297dc30f6dd142cf46c8'](result))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/9cb9b656dba98b09547e0d2df19dba8b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return (await Backendless.Data.of('Document').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((String('created >') + String((await BackendlessUI.Functions.Custom['fn_3e6beb363a8e0bbdd1ed31ed14c87a32']((new Date()))).valueOf())))))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/504309a481d2c7735a5928dc30b6e611/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var result, item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('Document').find(Backendless.DataQueryBuilder.create().setWhereClause((String('created > ') + String((await BackendlessUI.Functions.Custom['fn_3e6beb363a8e0bbdd1ed31ed14c87a32']((new Date()))).valueOf()))).setProperties('sum(priceNet)').setGroupBy('ownerId').setPageSize(1)));
  if (!list.length) {
    result = '0';
  } else {
    result = (await Promise.all(list.map(async item => {; return (getObjectProperty(item, 'sum'));})));
  }

  return (await BackendlessUI.Functions.Custom['fn_01eb5f7ce622297dc30f6dd142cf46c8'](result))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/190651cfb879d9025ad86ab3a73b543f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DocumentListPage', ({ 'userOid': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3792d331f2fa6076ddea70afb44612ac'), 'userOid')),'fullName': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3792d331f2fa6076ddea70afb44612ac'), 'userName')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/d2eaa752a2b50907834282f954e2fdc5/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_0f429df91b0f40b5392b7d46e052a65a']())

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DocumentPage', ({ 'objectId': (getObjectProperty(___arguments.selectedRecord, 'objectId')) }));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/home/components/61282d5e841d0078492caa23e8aa4d91/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
      return (await Backendless.Data.of('DocumentView').find(Backendless.DataQueryBuilder.create().setWhereClause(([(await BackendlessUI.Functions.Custom['fn_0f429df91b0f40b5392b7d46e052a65a']()),' and created >',((await BackendlessUI.Functions.Custom['fn_3e6beb363a8e0bbdd1ed31ed14c87a32']((new Date()))).valueOf())].join(''))).setProperties('userOid, userName, sum(priceNet) as priceNet, count(objectId) as counter').setGroupBy('userOid, userName').setPageSize(50)))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/home/components/c0e6b5f9f66b103904c39dff97af4587/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_01eb5f7ce622297dc30f6dd142cf46c8']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3792d331f2fa6076ddea70afb44612ac'), 'priceNet'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/home/components/423331ca406a2f1b0dce8fd65c872a45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('StatsPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/2454cde8d6cab9deaf5cb99bdff53251/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DocumentListPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/b1a59358073823a530df6f6fe95eb606/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DocDetailsListPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/b416d564e7c4e7c102452298ed23263d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DocumentListPage', ({ 'onlyToSend': 'true' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/home/components/97296e59c9519c49202a748d2b9b25a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DocumentListPage', ({ 'userOid': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3792d331f2fa6076ddea70afb44612ac'), 'userOid')),'fullName': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3792d331f2fa6076ddea70afb44612ac'), 'userName')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/2eca1862570168c4b0e74704dbc8e386/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('AdminUsersList', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/22b33bcae2ce62eaf9769e6968e24296/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserAccountPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/3d8dd0ffd7b59413304577ced41a4ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/92f16cb56197991aa75863b642ec384d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/b56363d59ca6140b58cb898853c851dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ContractorListPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/6347e641dd3d8db9b9ffd0e7d7a8501c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DistributorListPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/8c3f7d0cc8b5e91f81aa7f374b0b9601/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('SalesmanListPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/1b2d5b3546cd8506a06b1de4d4d86da6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DetailListPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/root/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (await Backendless.UserService.isValidLogin()) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22b33bcae2ce62eaf9769e6968e24296', true);
    ___arguments.context.pageData['helloUserText'] = (String('Witaj ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'name')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2eca1862570168c4b0e74704dbc8e386', ((await Backendless.UserService.getUserRoles()).includes('SuperAdmin')));
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22b33bcae2ce62eaf9769e6968e24296', false);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('UserLoginPage', undefined);
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/463fbf595bdd3cb41e96dfca26623c4e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 600)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/f817e8143b9a2b42945a4c9d7e12fa9b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 600)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/0223ea28c2ac042636aaeb0bebf2b135/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/b8235f971fe7a91b16f9456a269f465d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DetailListPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/2d08d4e6b59cf754777d0f188278ace3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('ContractorListPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/2c92e135d321c70300246fe9ea99c553/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('DistributorListPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_76a8fbef4d6ecaf8332aa2f27e536272/logic/7e21d8b6511d0752916c0cfeb6740125/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('SalesmanListPage', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0cca2f6d7d735f78cec98413dd43b44a/logic/7cf8a49cb99170a4baaedf5abb8fe3c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_f315d0987625e6df48afb5dfc7c5187f']((await Backendless.Data.of('Users').getObjectCount()), 0)) >= (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'licenseSalesmansQuantity'))) {
    (function (message) { alert(message) })((String('Twoja licencja ma wprowadzone ograniczenie ilości handlowców: ') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'licenseSalesmansQuantity'))));
  } else {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('3adb47a7178bc04bab8f23cdce4a4ea4');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0cca2f6d7d735f78cec98413dd43b44a/logic/589671d30a952999558c8beab30334b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!!(getObjectProperty(___arguments.context.pageData, 'objectId')).length) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.pageData, 'EditPageName')), ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'objectId')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0cca2f6d7d735f78cec98413dd43b44a/logic/397e8673253f8a11521409938d58a00a/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('397e8673253f8a11521409938d58a00a');

  },
  /* handler:onClose */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'TableName'))).remove( (getObjectProperty(___arguments.context.pageData, 'objectId')) );
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('397e8673253f8a11521409938d58a00a');

  },
  /* handler:onSubmit */
  /* handler:titleLogic */
  ['titleLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'objectName'))

  },
  /* handler:titleLogic */
  /* content */
}))

define('./components/reusable/r_0cca2f6d7d735f78cec98413dd43b44a/logic/f89343ef2118f2cb9bc4db64525ea37d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!!(getObjectProperty(___arguments.context.pageData, 'objectId')).length) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('397e8673253f8a11521409938d58a00a');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0cca2f6d7d735f78cec98413dd43b44a/logic/3adb47a7178bc04bab8f23cdce4a4ea4/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3adb47a7178bc04bab8f23cdce4a4ea4');

  },
  /* handler:onClose */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('3adb47a7178bc04bab8f23cdce4a4ea4');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.pageData, 'EditPageName')), (await Backendless.UserService.register( new Backendless.User({ 'name': ___arguments['inputValue'],'password': 'zamawiaj24' }) )));

  } catch (error) {
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));

  }

  },
  /* handler:onSubmit */
  /* content */
}))

define('./components/reusable/r_dccaec6874a69c6dcdc151bb27bf7a97/logic/7cf8a49cb99170a4baaedf5abb8fe3c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.pageData, 'EditPageName')), (await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'TableName'))).save( ({ 'name': '' }) )));

  } catch (error) {
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_dccaec6874a69c6dcdc151bb27bf7a97/logic/589671d30a952999558c8beab30334b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!!(getObjectProperty(___arguments.context.pageData, 'objectId')).length) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.pageData, 'EditPageName')), ({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'objectId')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_dccaec6874a69c6dcdc151bb27bf7a97/logic/397e8673253f8a11521409938d58a00a/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('397e8673253f8a11521409938d58a00a');

  },
  /* handler:onClose */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of((getObjectProperty(___arguments.context.pageData, 'TableName'))).remove( (getObjectProperty(___arguments.context.pageData, 'objectId')) );
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('397e8673253f8a11521409938d58a00a');

  },
  /* handler:onSubmit */
  /* handler:titleLogic */
  ['titleLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'objectName'))

  },
  /* handler:titleLogic */
  /* content */
}))

define('./components/reusable/r_dccaec6874a69c6dcdc151bb27bf7a97/logic/f89343ef2118f2cb9bc4db64525ea37d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!!(getObjectProperty(___arguments.context.pageData, 'objectId')).length) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('397e8673253f8a11521409938d58a00a');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_4232b141cf5dc01b7dbcd89c1042d92a/logic/0e9f253c2e785dcdc55aae13f00503a1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_4232b141cf5dc01b7dbcd89c1042d92a/logic/00b276c2b0c5baaa9282670dd683dc65/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'PageTitle'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_4232b141cf5dc01b7dbcd89c1042d92a/logic/4001ad85dacd9304c4312b5ccc5e0242/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_4232b141cf5dc01b7dbcd89c1042d92a/logic/a3f6f9092534b8ee712e994af848019c/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'logoUrl'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

